import React from "react";
import { all_routes } from "../../../router/all_routes";
import { Link } from "react-router-dom";

const CenterBreadcrumb = () => {
  const routes = all_routes;
  return (
    <div className="col-md-12">
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-3">
        <div className="mb-0">
          <h3 className="page-title mb-1">Center Details</h3>
          <nav>
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <Link to={routes.adminDashboard}>Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to={routes.centerList}>Centers</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Center Details
              </li>
            </ol>
          </nav>
        </div>
        <div className="d-flex flex-wrap gap-2">
          {/* <Link
            to="#"
            className="btn btn-light"
            data-bs-toggle="modal"
            data-bs-target="#login_detail"
          >
            <i className="ti ti-lock me-2" />
            Login Details
          </Link> */}
          {/* <Link
            to={routes.editCenter}
            className="btn btn-primary d-flex align-items-center"
          >
            <i className="ti ti-edit me-2" />
            Edit Center
          </Link> */}
        </div>
      </div>
    </div>
  );
};

export default CenterBreadcrumb;
